import {
  useDevice,
  useLocale,
} from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/DeviceContext";
import { useSessionContext } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/SessionContext";
import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";
import type { UserRecipient } from "@deskpro-product/messenger-api-schemas/messenger/api/conversation/entities";
import { useMemo } from "react";

const useRecipient = (): UserRecipient | null => {
  const platform = useLauncherStore((state) => state.platform);
  const { session } = useSessionContext();
  const { locale } = useLocale();
  const { device_id } = useDevice();

  return useMemo(
    () =>
      session?.user
        ? {
            type: "user",
            id: session?.user.id,
            external_id: device_id,
            device: {
              device_id: device_id,
              type: platform,
            },
            is_author: true,
            name: session?.user.name,
            first_name: session?.user.first_name,
            last_name: session?.user.last_name,
            email: session?.user.email ?? undefined,
            locale: locale,
          }
        : null,
    [platform, device_id, session?.user, locale],
  );
};

export default useRecipient;
